import { Modal, Box, Button, Icon } from '@palmetto/palmetto-components';

interface ArchiveConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ArchiveConfirmationModal({ isOpen, onClose, onConfirm }: ArchiveConfirmationModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Confirm Archive" onDismiss={onClose} maxWidth="4xl">
      <Modal.Body padding="0">
        <Box direction="row" childGap="sm" background="warning" padding="lg" maxWidth="5xl" alignItems="center">
          <Icon name="t-warning" size="xl" color="warning-500" />
          <Box textAlign="left">
            <Box fontSize="md" fontWeight="bold">
              Confirm Archive
            </Box>
            <Box>Are you sure you want to archive this document? This action cannot be undone.</Box>
          </Box>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Box justifyContent="flex-end">
          <Box direction="row" childGap="sm">
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onConfirm}>
              Ok
            </Button>
          </Box>
        </Box>
      </Modal.Footer>
    </Modal>
  );
}
